<template>
<section class="px-4 py-10 mx-auto max-w-6xl">
    <div class="mb-5 text-xl text-center md:text-2xl font-ww-bold">
        References:
    </div>

    <div class="space-y-4">
        <div class="space-y-1 text-sm font-ww-regular sm:text-base" v-html="references"></div>
    </div>
</section>
</template>

<script setup>
defineProps({
  references: {
    type: String,
    default: `<p>[1] Raz, N., et al. (2005). <em>Regional brain changes in aging healthy adults: general trends, individual differences and modifiers.</em> Cerebral Cortex, 15(2), 167–179.</p>

<p>[2] Mitchell, G.F., et al. (2007). <em>Arterial stiffness, pressure and flow pulsatility and brain structure and function.</em> Brain, 130(Pt 4), 1513–1523.</p>

<p>[3] Fotenos, A.F., et al. (2005). <em>Normative estimates of cross-sectional and longitudinal brain volume decline in aging and Alzheimer's disease.</em> Neurology, 64(6), 1032–1039.</p>`
  }
})

defineBuilderComponent({
    friendlyName: 'ReferencesWithTitle',
    canHaveChildren: false,
    inputs: [
        {
            name: 'references',
            type: 'richText',
            defaultValue: `<p>[1] Raz, N., et al. (2005). <em>Regional brain changes in aging healthy adults: general trends, individual differences and modifiers.</em> Cerebral Cortex, 15(2), 167–179.</p>

<p>[2] Mitchell, G.F., et al. (2007). <em>Arterial stiffness, pressure and flow pulsatility and brain structure and function.</em> Brain, 130(Pt 4), 1513–1523.</p>

<p>[3] Fotenos, A.F., et al. (2005). <em>Normative estimates of cross-sectional and longitudinal brain volume decline in aging and Alzheimer's disease.</em> Neurology, 64(6), 1032–1039.</p>`
        }
    ]
})
</script>